export function ItemTableRowSkeleton() {
  return (
    <>
      <td className="twc-py-6 twc-pl-4 twc-animate-pulse">
        <div className="twc-flex twc-gap-4">
          <div className="twc-grow twc-basis-28 twc-aspect-4/5 twc-bg-gray-200"></div>
          <div className="twc-grow-[999] twc-basis-0">
            <div className="twc-w-5/6 twc-h-7 twc-bg-gray-200 twc-rounded twc-mb-1.5"></div>
            <div className="twc-bg-gray-200 twc-w-1/3 twc-h-5 twc-rounded twc-mb-1"></div>
            <div className="twc-bg-gray-200 twc-w-2/3 twc-h-5 twc-rounded"></div>
          </div>
        </div>
      </td>

      <td className="twc-px-8 twc-py-6 twc-align-top twc-text-center twc-animate-pulse">
        <div className="twc-bg-gray-200 twc-w-24 twc-h-9 twc-rounded twc-mb-4 twc-mx-auto" />

        <div className="twc-mx-auto twc-w-16 twc-h-5 twc-mb-4 twc-bg-gray-200 twc-rounded" />
      </td>

      <td className="twc-p-6 twc-align-top twc-animate-pulse">
        <div className="twc-w-14 twc-h-7 twc-bg-gray-200 twc-rounded twc-ml-auto" />
      </td>
    </>
  )
}
